module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020/0155.jpg?v=cf92879d";